import Head from 'expo-router/head';

import { BirthdayScreen } from '@fhs/loyalty';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function BirthdayPage() {
  return (
    <>
      <Head>
        <title>Birthday Reward - Firehouse Subs</title>
      </Head>
      <BirthdayScreen />
    </>
  );
}
